import { render, staticRenderFns } from "./heroNews.vue?vue&type=template&id=743a97b8&scoped=true&"
import script from "./heroNews.vue?vue&type=script&lang=js&"
export * from "./heroNews.vue?vue&type=script&lang=js&"
import style0 from "./heroNews.vue?vue&type=style&index=0&id=743a97b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743a97b8",
  null
  
)

export default component.exports